/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyInviteDto
 */
export interface CompanyInviteDto {
  /**
   *
   * @type {string}
   * @memberof CompanyInviteDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof CompanyInviteDto
   */
  invite: string;
}

export function CompanyInviteDtoFromJSON(json: any): CompanyInviteDto {
  return CompanyInviteDtoFromJSONTyped(json, false);
}

export function CompanyInviteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyInviteDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    invite: json["invite"],
  };
}

export function CompanyInviteDtoToJSON(value?: CompanyInviteDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    invite: value.invite,
  };
}
